
import { SIGN_UP } from '~/constants/api'
import VRadio from '~/components/ui/VRadio'
import VLabel from '~/components/ui/VLabel'
import VButton from '~/components/ui/VButton'
import VCheckbox from '~/components/ui/VCheckbox'
import VFormGroup from '~/components/ui/VFormGroup'
import DynamicTextModal from '~/components/modals/DynamicTextModal'

export default {
    layout: 'empty',
    middleware: [
        'isNotAuth'
    ],
    data() {
        return {
            email: '',
            agreement: false,
            password: '',
            repeatPassword: '',
            role: 'kettari',
            emailError: '',
            privacyCheckbox: false,
            termsCheckbox: false,
        }
    },
    watch: {
        email() {
            this.emailError = ''
        }
    },
    computed: {
        isValid() {
            return this.email && this.agreement && this.password && this.repeatPassword && this.passwordEqual && this.privacyCheckbox && this.termsCheckbox
        },
        passwordEqual() {
            return this.password === this.repeatPassword
        },
        privacyText() {
            return this.$t('pages.signUp.privacyText')
        },
        termsText() {
            return this.$t('pages.signUp.termsText')
        }
    },
    methods: {
        signInPage() {
            window.open(this.glLoginUrl(), '_self');
        },
        submit() {
            this.$axios.post(SIGN_UP, {
                email: this.email,
                password: this.password,
                is_agreement: this.agreement,
                role: this.role,
                is_rules: true,
            }).then(() => {
                this.$modal.show(
                    DynamicTextModal,
                    {
                        title: this.$t('general.congratulations'), 
                        text: this.$t('pages.signUp.successText'),
                        buttons: [{
                            title: this.$t('general.ok'),
                            handler: () => {
                                this.$modal.hide('dynamic-text-modal')
                            }
                        }]
                    }, {
                        maxWidth: 480,
                        adaptive: true,
                        clickToClose: false,
                        height: 'auto',
                        name: 'dynamic-text-modal',
                    },
                    { 'before-close': () => {this.$router.push('/')} }
                )
            }).catch(err => {
                this.emailError = err.response.data.message
            })
        },
    },
    components: {
        VLabel,
        VRadio,
        VButton,
        VCheckbox,
        VFormGroup,
    }
}
